import React, { FC, useEffect, useState, useMemo } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { cartMobx, mallMobx } from 'mobx/mall'
import ProductItem from '../../ProductItem'
import TopProductItem from '../../ProductItem/TopProductItem'
import { MallStyleController } from '@ctrls/mallController'
import { Empty, WaterfallSkeleton } from '@cps'
import { debounce as _debounce, keyBy } from '@dt/fe-utils/dist/lodash'
import { decorationMobx, themeMobx } from '@mobxStore'
import './index.scss'

interface IProps {
  lazy?: boolean;
  products?: IMallViewProduct[];
  productsTop?: IMallViewProduct[];
  selectCategoryNo?: string;
}

// 存储计算结果
const lineToResult = {}

const WaterfallTemplate: FC<IProps> = ({ lazy = true, products: _products = [], productsTop: _productsTop = [] }) => {
  const [products, setProducts] = useState([])
  const [productsTop, setProductsTop] = useState([])
  const [productStyleMap, setProductStyleMap] = useState({} as {
    [no: string]: {
      left: number;
      top: number;
    };
  })
  const [height, setHeight] = useState(420)
  const hashProduct = useMemo(() => {
    return products.map(p => p.no).join('')
  }, [products])
  // 设置商品置顶
  const calcWaterfall = () => {
    const payload = MallStyleController.waterfall(products, lazy)
    if (payload) {
      const { styleMap, height } = payload
      lineToResult[hashProduct] = payload
      setProductStyleMap(styleMap)
      setHeight(height)
    } else {
      setTimeout(() => {
        calcWaterfall()
      }, 300)
    }
  }
  useEffect(() => {
    if (products.length && hashProduct) {
      if (lineToResult[hashProduct]) {
        setProductStyleMap(lineToResult[hashProduct].styleMap)
        setHeight(lineToResult[hashProduct].height)
      } else {
        setTimeout(() => {
          calcWaterfall()
        }, 50)
      }
    }
  }, [hashProduct])
  useEffect(() => {
    setProductsTop(MallStyleController.setProductImgHeight(_productsTop, 1))
    setProducts(MallStyleController.setProductImgHeight(_products, 2, 2))
    window.addEventListener(window.onorientationchange ? 'orientationchange' : 'resize', () => {
      calcWaterfall()
    }, false)
  }, [_products])
  useEffect(() => {
    window.addEventListener(window.onorientationchange ? 'orientationchange' : 'resize', () => {
      calcWaterfall()
    }, false)
  }, [])
  return (
    <>
      {
        mallMobx.isLoading ? <WaterfallSkeleton /> : mallMobx.products.length ? ( // 且有餐品
          <div className='mall-product-list-content'>
            {/* 置顶商品 */}
            <div className='mall-product-top-list-wrapper'>
              {
                productsTop.map((product) => {
                  const count = cartMobx.cartResult?.productNoToCntMap?.[product.no] || 0
                  return (<TopProductItem decorate={decorationMobx.mallGlobalDecorates || {} as IMallGlobalDecorates} key={product.no} product={product} count={count} backgroundMode={themeMobx.data.backgroundMode} />)
                })
              }
            </div>
            <div className='mall-waterfall-template' style={{ height: products.length ? height : 0 }}>
              {
                products.map((product) => {
                  const count = cartMobx.cartResult?.productNoToCntMap?.[product.no] || 0
                  return (<ProductItem decorate={decorationMobx.mallGlobalDecorates || {} as IMallGlobalDecorates} style={productStyleMap[product.no] || { visibility: 'hidden' }} key={product.no} product={product} count={count} lazy={lazy} backgroundMode={themeMobx.data.backgroundMode} imgLoaded={mallMobx.imgLoadingMap[product.no]} />)
                })
              }
            </div>
            {mallMobx.products.length >= 4 && <div className='product-list-deep'>{i18n.t('mall.deep')}</div>}
            {themeMobx.brandTemplateDetails?.globalDecorates?.tabBarSetting?.pagesShow && themeMobx.brandTemplateDetails?.globalDecorates?.tabBarSetting?.pagesShow?.['mall'] === 1 && <div className='product-list-deep-tab-fill'></div>}
          </div>
        ) : ( // 无商品
          <Empty msg={i18n.t('mall.noProducts')} height='55vh' />
        )
      }
    </>
  )
}
export default observer(WaterfallTemplate)
